import clone from "@npm/clone";
import productService from "../services/product";
import filtersDict from "../dict/filters";

const initialFilters = {
  sort: "pertinence",
  name: "",
  colors: [],
  years: [],
  capacity: "",
  "min_price": null,
  "max_price": null,
  families: [],
  only_bio: 0
};

const sanitizeFilter = obj => {
  const filters = clone(obj);

  for (const f in filters) {
    if (!Object.keys(initialFilters).includes(f)) {
      delete filters[f];
    }
  }

  return filters;
};

export default {
  namespaced: true,
  state: {
    filterOptions: null,
    filters: clone(initialFilters)
  },
  mutations: {
    setFilterOptions(state, filterOptions) {
      state.filterOptions = {
        years: Array.from({ length: 50 }, (v, k) => (new Date().getFullYear() - k).toString()),
        ...filterOptions
      };
    },
    setFilters(state, filters) {
      state.filters = sanitizeFilter(filters);
    },
    toggleColor(state, color) {
      const colors = state.filters.colors;

      state.filters.colors = colors.includes(color) ? colors.filter(c => c !== color) : [...colors, color];
    },
    setYears(state, years) {
      state.filters.years = years;
    },
    setCapacity(state, capacity) {
      state.filters.capacity = capacity;
    },
    setOnlyBio(state, bio) {
      state.filters.only_bio = bio ? 1 : 0;
    },
    setMinPrice(state, price) {
      state.filters.min_price = price ? Math.floor(price * 100) : null;
    },
    setMaxPrice(state, price) {
      state.filters.max_price = price ? Math.floor(price * 100) : null;
    },
    setFamilies(state, families) {
      state.filters.families = families;
    },
    resetFilters(state) {
      state.filters = clone(initialFilters);
    }
  },
  actions: {
    initialize({ dispatch, commit }) {
      return dispatch("auth/getUser")
        .then(() => commit("initialize"))
        .catch(() => commit("initialize"));
    },
    getFilterOptions({ commit, state }) {
      if (!state.filterOptions) {
        productService.getFilters()
          .then(({ data: filters }) => commit("setFilterOptions", filters));
      }
    }
  },
  getters: {
    activeFilterCount: (state, getters) => getters.activeFilters.length,
    activeFiltersByName: (state, getters) => getters.activeFilters.map(f => filtersDict[f]),
    activeFilters: state => Object.keys(state.filters)
      .filter(f => !["name", "sort"].includes(f))
      .filter(f => f !== "only_bio" || parseInt(state.filters[f]) === 1)
      .filter(f => Array.isArray(state.filters[f])
        ? state.filters[f].length > 0
        : state.filters[f] !== null && state.filters[f] !== "")
  }
};
